import { InteractionType } from "@azure/msal-browser";

export const DEFAULT_INTERACTION_TYPE = InteractionType.Redirect;
